import React, { useState, useContext, useEffect } from "react";
import {FormattedMessage, useIntl} from "react-intl";
import { Button, Row, Col } from "reactstrap";
import { Link, useHistory, useParams } from "react-router-dom";

import EventContext from "../../contexts/event";
import UserContext from "../../contexts/user";
import getEncodedImageUrl from "../../helpers/get-encoded-image";
import { Presentation, VersionList } from "../../types/presentation";

import { timeFromMinutes } from "../../helpers";
import axios from "axios";
import ImgToolTip from "../ImgTooltip";
import {DateTime} from "luxon";

const PresentationItem: React.FC<{
  presentation: Presentation;
  isVirtual: boolean;
  showAgenda: boolean;
  show_video_views: boolean
}> = ({ presentation, isVirtual, showAgenda , show_video_views}) => {
  const { event_slug } = useParams<{
    event_slug: string;
  }>();
  const eventContext = useContext(EventContext);
  const userContext = useContext(UserContext);
  const [openDetails, setOpenDetails] = useState(false);
  const [plays, setPlays] = useState(0);
  const history = useHistory();
  const [versionId, setVersionId] = useState("");
  const intl = useIntl();

  let token: any = localStorage.getItem(`token-${event_slug}`);

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_API_ENDPOINT}/api/presentation/${presentation._id}/version-plays`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        setPlays(response.data.data);
      })
      .catch((error) => {
         console.log(error);
      });
  }, []);
  //  console.log("userContext", userContext);
  let versionItem = presentation.versions?.filter(function (version) {
    return version.online == true;
  });

   console.log("home_page","PresentationItem");

return(<>
        {presentation.header && (
            <div className="day-text-schedule">
                <span className="day">{intl.formatMessage({ id: 'day' })}  {presentation.day}</span>
                <span className="date">
              {DateTime.fromISO(presentation.date)
                  .setLocale(intl.locale)
                  .toLocaleString(DateTime.DATE_HUGE)}
            </span>
            </div>
        )}
        <div className="schedule-bar m-b-20">

            <div className="d-none d-lg-block">
                <Row noGutters>

                    <Col sm={8} md={8} lg={9}>
                        <div className="schedule-contianer">
                            <div className="speaker-presentation d-flex border-radius justify-content-between">
                                {presentation.speaker_info &&
                                presentation.speaker_info.picture &&
                                presentation.speaker_info.picture.split("net/")[1] !==
                                "undefined" ? (
                                    <img
                                        width={76}
                                        height={76}
                                        src={getEncodedImageUrl(
                                            presentation.speaker_info.picture,
                                            76,
                                            76
                                        )}
                                        alt={presentation.speaker_info.firstName}
                                    />
                                ) : (
                                    <img
                                        width={76}
                                        height={76}
                                        src={"/images/placeholder.svg"}
                                        alt={presentation.speaker_info.firstName}
                                    />
                                )}
                                <div className="speaker-details">
                                    <h4>{presentation.name}</h4>

                                    <span>
                  {presentation.speaker_info &&
                      presentation.speaker_info.title}{" "}
                                        {presentation.speaker_info &&
                                            presentation.speaker_info.firstName}{" "}
                                        {presentation.speaker_info &&
                                            presentation.speaker_info.lastName}
                </span>
                                </div>
                                <div>
                                    <div>
                                        {show_video_views ? (
                                            <div className="plays-count">
                                                <img
                                                    width="18"
                                                    height="11"
                                                    src={`/images/eye.svg`}
                                                />
                                                <span> {plays}</span>
                                            </div>
                                        ) : (
                                            ""
                                        )}
                                        <div
                                            className={`schedule-button ${
                                                !show_video_views
                                                    ? "margin-top-abscence-of-views"
                                                    : ""
                                            }`}
                                        >

                                            <img
                                                src={`/images/my-schedule-white-light.svg`}
                                                alt="Test"
                                                className="schedule_button_light"
                                                onClick={function () {
                                                    // setMyschedule(true);
                                                    // upadteScheduleStatus(schedule);
                                                }}
                                            />
                                            <img
                                                src={`/images/my-schedule-white-dark.svg`}
                                                alt="Test"
                                                className="schedule_button_dark"
                                                onClick={function () {
                                                    // setMyschedule(true);
                                                    //upadteScheduleStatus(schedule);
                                                }}
                                            />

                                        </div>
                                        <div
                                            className={`schedule-button-download ${
                                                !show_video_views ? "margin-abscence-of-views" : ""
                                            }`}
                                        >

                                            {presentation.pdfConvert ? (
                                                <a
                                                    // className="trash"
                                                    //  className="btn_download_photos"
                                                    // href={`${process.env.REACT_APP_ASSET_URL}${pdfUrl}`}
                                                    // href={
                                                    //   presentation.pdfUrl
                                                    //     ? getS3FileUrl(presentation.pdfUrl)
                                                    //     : "#"
                                                    // }
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    download
                                                >
                                                    {/* <ImgToolTip
                          className={` download_icon download_icon_schedule `}
                          intl={Intl}
                          placement="left"
                          tooltiptext="schedule.link.download"
                          id="tooltip-download-latest"
                          img={`/images/schedule-download.svg`}
                        /> */}


                                                </a>
                                            ) : (
                                                // <ImgToolTip
                                                //     intl={intl}
                                                //     placement="top"
                                                //     tooltiptext="link.download"
                                                //     id={`tooltip-download-ppt-${presentation._id}`}
                                                //     img="/icons/download.png"
                                                //     // className={""}
                                                //     className={"download_icon_schedule"}
                                                //   />
                                                ""
                                            )}
                                        </div>
                                    </div>

                                    {/* <div className="schedule-button-download"> */}
                                </div>
                                {/* <div className="public-link">
          <img width={12} height={16} src={"/icons/link-ico.svg"} />
            <span>
              <FormattedMessage id="presentation.public.link" />
            </span>
          </div> */}
                            </div>
                            <div
                                className={`schedule-details ${
                                    openDetails ? "show-details" : "hide-details"
                                }`}
                            >
                                {(presentation.type_info ||
                                    presentation.color_info ||
                                    presentation.association_info) && (
                                    <div
                                        className={`details   ${
                                            presentation.publicVideo &&
                                            presentation.video &&
                                            presentation.video.id
                                                ? ""
                                                : "schedule-border"
                                        }`}
                                    >
                                        <div className="type-theme">
                                            {presentation.type_info && (
                                                <>
                        <span>
                          <img
                              src={getEncodedImageUrl(
                                  presentation.type_info.icon,
                                  36,
                                  36,
                                  "contain"
                              )}
                              alt={presentation.type_info.name}
                          />
                            {presentation.type_info.name}
                        </span>
                                                </>
                                            )}
                                            <div className="vl"></div>

                                            {presentation.color_info && (
                                                <span>
                        <span
                            style={{
                                backgroundColor:
                                presentation.color_info.color,
                                width: 40,
                                height: 40,
                                borderRadius: 5,
                                display: "inline-block",
                                verticalAlign: "middle",
                            }}
                        ></span>
                                                    {presentation.color_info.name}
                      </span>
                                            )}
                                        </div>
                                        {presentation.association_info && (
                                            <span className="ass">
                      <img
                          // width="40"
                          // height="40"
                          src={getEncodedImageUrl(
                              presentation.association_info.logo,
                              36,
                              36
                          )}
                          alt={presentation.association_info.name}
                      />
                                                {presentation.association_info.name}
                    </span>
                                        )}
                                    </div>
                                )}
                                {/* double run and this is working for both presentation and version attribute */}
                                {presentation.publicVideo &&
                                    presentation.video &&
                                    presentation.video.id && (
                                        <div className="watch-video">
                                            <Link
                                                to={`/${eventContext.slug}/${presentation._id}${document.location.search}`}
                                            >
                                                <img src="/icons/video.svg" alt="video" />
                                                <FormattedMessage id="button.watch-video" />
                                            </Link>
                                        </div>
                                    )}

                                {/* // : (
          //   presentation.versions?.some((el) => el.online === true) && (
          //     <div className="watch-video">
          //       <Link
          //         // "bad42d86-2860-51b2-a2e5-52a608b4ae6d"
          //         to={`/${eventContext.slug}/my-pres/${presentation._id}/video/${versionItem[0]?.versionId}/watch`}
          //       >
          //         <img src="/icons/video.svg" alt="video" />
          //         <FormattedMessage id="button.watch-video" />
          //       </Link>
          //     </div>
          //   )
          // )} */}
                                <div className="sch-btns-container-d">
                                    <Button
                                        className="sch-btns"
                                        onClick={() => {
                                            userContext.user? history.push(
                                                    `/${eventContext.slug}/my-presentations/${presentation._id}/videos`
                                                )
                                                : userContext.setShowLogin(true);
                                        }}
                                    >
                                        <img alt="quiz" src="/icons/my-videos-ico.svg" width={23} />
                                        <FormattedMessage id="presentation.my.videos" />
                                    </Button>
                                    {eventContext.forum ? (
                                        <React.Fragment>
                                            {userContext.user ? (
                                                <Link
                                                    className="sch-btns"
                                                    to={`/${eventContext.slug}/${presentation._id}/forum${document.location.search}`}
                                                >
                                                    <img alt="forum" src="/icons/forum.svg" />
                                                    FORUM
                                                </Link>
                                            ) : (
                                                <Button
                                                    className="sch-btns"
                                                    onClick={() => {
                                                        userContext.setShowLogin(true);
                                                    }}
                                                >
                                                    <img alt="forum" src="/icons/forum.svg" />
                                                    FORUM
                                                </Button>
                                            )}
                                        </React.Fragment>
                                    ) : (
                                        <></>
                                    )}


                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col sm={3} md={3} lg={2}>
                        <div className="time-container-schedule">
                            <div className="darkoverlay">
                                {isVirtual ? (
                                    <h5>&nbsp;</h5>
                                ) : (
                                    <h5>
                                        {timeFromMinutes(presentation.time)} -{" "}
                                        {timeFromMinutes(presentation.end_time)}
                                    </h5>
                                )}
                                {isVirtual ? (
                                    <span>&nbsp;</span>
                                ) : (
                                    presentation.room_info && (
                                        <span>{presentation.room_info.name}</span>
                                    )
                                )}
                            </div>
                            <Button
                                onClick={() => setOpenDetails(!openDetails)}
                                color="primary"
                                className="arrow-button"
                            >
                                <img
                                    className={openDetails ? "chev-rotate" : ""}
                                    src="/icons/chev-white.svg"
                                    alt="chev-white"
                                />
                            </Button>
                        </div>
                    </Col>
                </Row>
            </div>

            {/* Mobile Below */}
            <div className="d-block d-lg-none">

                <Row noGutters>
                    <Col xs={8}>
                        <div className="schedule-contianer_mo_schedule">
                            <div className="speaker-presentation_mop">
                                <h4 className="speaker-presentation_mo">
                                    { presentation.name.slice(0,70)}
                                </h4>

                                {show_video_views ? (
                                    <div className="plays-count">
                                        <img width="18" height="11" src={`/images/eye.svg`} />
                                        <span> {plays}</span>
                                    </div>
                                ) : (
                                    ""
                                )}
                            </div>
                        </div>
                    </Col>
                    <Col xs={4}>
                        <div className="schedule-contianer_mo_schedule_time">
                            <div className="speaker-presentation_mop">
                                {/* <h4 className="speaker-presentation_mo">{presentation.name}</h4>
             */}

                                <div className="time_content">
                                    {timeFromMinutes(presentation.time)}
                                    {/* -{" "}
            {timeFromMinutes(presentation.end_time)} */}
                                </div>
                                <div className="time_content">
                                    {/* {timeFromMinutes(presentation.time)} -{" "} */}
                                    {timeFromMinutes(presentation.end_time)}
                                </div>
                                {presentation.room_info && (
                                    <span className="room_content">
                {presentation.room_info.name}
              </span>
                                )}
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row noGutters>
                    <Col xs={2}>

                        <div className="presentation-icon_mo_schedule" >



                            <img
                                src={`/images/myschedule.svg`}
                                alt="Test"
                                className="schedule_button_light"
                                onClick={function () {
                                    // setMyschedule(false);
                                    //upadteScheduleStatus(schedule);
                                }}
                            />

                        </div>

                        <div
                            className={
                                presentation.pdfConvert
                                    ? "time_room_schedule"
                                    : "time_room_schedule_white"
                            }
                        >


                            <a

                                rel="noopener noreferrer"
                            >
                                <img
                                    width="34"
                                    // height="42"
                                    src={`/images/schedule-download-dark.svg`}
                                    alt="Test"
                                    onClick={function () {
                                        if (presentation.pdfUrl) {
                                            //getS3FileUrl(presentation?.pdfUrl);
                                        }
                                    }}
                                />
                            </a>


                        </div>
                    </Col>
                    <Col xs={4}>
                        <div className="time-container time-container-mob">
                            <div className="arrow btn-primary">
                                <Button
                                    onClick={() => setOpenDetails(!openDetails)}
                                    color="primary"
                                >
                                    <img
                                        className={openDetails ? "chev-rotate" : ""}
                                        src="/icons/chev-white.svg"
                                        alt="chev-white"
                                    />
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="schedule-contianer">
                            <div
                                className={`schedule-details ${
                                    openDetails ? "show-details" : "hide-details"
                                }  `}
                            >
                                {(presentation.type_info ||
                                    presentation.color_info ||
                                    presentation.association_info) && (
                                    <div className={`details     `}>
                                        <div className="type-theme">
                                            {presentation.type_info && (
                                                <div>
                                                    <img
                                                        width={44}
                                                        height={40}
                                                        src={getEncodedImageUrl(
                                                            presentation.type_info.icon,
                                                            30,
                                                            30
                                                        )}
                                                        alt={presentation.type_info.name}
                                                    />
                                                    <span>{presentation.type_info.name}</span>
                                                </div>
                                            )}
                                            {/* changes */}
                                        </div>
                                        <div>
                                            {presentation.color_info && (
                                                <div>
                                                    <div
                                                        style={{
                                                            backgroundColor: presentation.color_info.color,
                                                            width: 44,
                                                            height: 40,
                                                            borderRadius: 5,
                                                            display: "inline-block",
                                                            verticalAlign: "middle",
                                                        }}
                                                    ></div>
                                                    <span>{presentation.color_info.name}</span>
                                                </div>
                                            )}
                                        </div>
                                        {presentation.association_info && (
                                            <div className="ass" style={{ marginTop: "10px" }}>
                                                {presentation.association_info.logo ? (
                                                    <img
                                                        width={44}
                                                        height={40}
                                                        src={getEncodedImageUrl(
                                                            presentation.association_info.logo,
                                                            30,
                                                            30
                                                        )}
                                                        alt="type"
                                                    />
                                                ) : (
                                                    ""
                                                )}

                                                <span>{presentation.association_info.name}</span>
                                            </div>
                                        )}
                                    </div>
                                )}
                                <div className="details-schedule">
                                    {presentation.publicVideo &&
                                        presentation.video &&
                                        presentation.video.id && (
                                            <Link
                                                className="schedule-btns"
                                                to={`/${eventContext.slug}/${presentation._id}${document.location.search}`}
                                            >
                                                <img src="/icons/video.svg" alt="video" />
                                                <span>
                      <FormattedMessage id="button.watch-video" />
                    </span>
                                            </Link>
                                        )}

                                    <Button
                                        className="schedule-btns"
                                        onClick={() => {
                                            userContext.user? history.push(
                                                    `/${eventContext.slug}/my-presentations/${presentation._id}/videos`
                                                )
                                                : userContext.setShowLogin(true);
                                        }}
                                    >
                                        <img alt="quiz" src="/icons/my-videos-ico.svg" />
                                        <FormattedMessage id="presentation.my.videos" />
                                    </Button>
                                    {eventContext.forum ? (
                                        <Link
                                            className="schedule-btns"
                                            to={`/${eventContext.slug}/${presentation._id}/forum${document.location.search}`}
                                        >
                                            <img alt="forum" src="/icons/forum.svg" />
                                            <span>FORUM</span>
                                        </Link>
                                    ) : (
                                        <></>
                                    )}

                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    </>

)


};

export default PresentationItem;
